import PackageCard from "../components/PackageCard";
import PaymentMethod from "../components/PaymentMethod";
import BenefitsTable from "../components/BenefitsTable";
import VipTable from "./variables/VipTable";
import {useEffect, useRef, useState} from "react";
import usePackages from "../hooks/usePackages";
import LoadingCard from "../components/LoadingCard";
import {BuyPackageModal} from "../../../../Modals/buy-package-modal";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ApplyCoupon from "../../../../components/apply-coupon/apply-coupon";

export default function Vip({className, ...props}) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const referral_code = queryParams.get('referral_code');
    const [data, isLoading, actions] = usePackages("VIP", {
        referral_code: referral_code
    })
    const packages = data?.results || []
    const [selectedPackage, setSelectedPackage] = useState({
        name: "FREE",
        price: 0
    })
    const [isOpen, setOpen] = useState(false)


    useEffect(() => {
        if (!selectedPackage) {
            setSelectedPackage(packages?.[0])
        }
    }, [packages])

    useEffect(() => {
        if (selectedPackage?.name !== "FREE") {
            const payment_method = document.getElementById("payment-method")
            if (!payment_method) return
            payment_method.scrollIntoView({behavior: "smooth"})
        }
    }, [selectedPackage]);


    return (


        <div className={"w-full  mt-10"}>

            <BuyPackageModal
                referral_code={referral_code}
                isOpen={isOpen} setOpen={setOpen} selectedPackage={selectedPackage}/>

            <div className={"mx-3 md:w-[300px] flex gap-2 justify-center items-center flex-col py-4 md:mx-auto"}>
                <div className={"font-semibold"}>
                    Have a referral code? Enter it here
                </div>
                <ApplyCoupon
                    code={referral_code}
                    clearCode={() => {
                        if (location.search.includes("referral_code")) {
                            navigate(location.pathname)
                        }
                    }}
                    applyCode={(code) => {
                        if (code && code.length > 0) {
                            navigate(`${location.pathname}?referral_code=${code}`)
                        }
                    }}
                />
            </div>
            <div className={`px-8 lg:px-[7rem] flex py-2  flex-col ${className}`}>
                <div className={"w-full flex flex-col justify-center items-center"}>
                    <p className={"text-center w-full lg:w-1/2  text-black text-xl lg:text-[2.25rem] font-[700]"}>
                        Upgrade to VIP to gain access to 15000 questions & answers
                    </p>
                    <p className={"text-center  mt-2 lg:mt-8 text-gray-400 text-xl font-normal"}>
                        If You Have Elite Pass, Download Guide and
                        Answer Templates From <span>
                        <Link to={"/tools/material"} className={"text-secondary-900"}>Here.</Link>

                    </span>
                    </p>

                    <div
                        className={"w-full  mt-4 lg:mt-16 mb-4  xl:w-3/5 grid grid-cols-1 md:grid-cols-2  gap-2 lg:gap-10 "}>
                        <PackageCard
                            isSelected={selectedPackage?.name === "FREE"}
                            onClick={() => setSelectedPackage({name: "FREE", price: 0})}
                            description={"10 questions per day"}
                            name={"FREE"}
                            price={"0"}/>

                        {
                            packages?.map((item, i) => (
                                <PackageCard key={i} isSelected={selectedPackage?.name === item.name}
                                             description={item?.description}
                                             oldPrice={item?.old_price}
                                             onClick={() => setSelectedPackage(item)} name={item.name}
                                             price={item.price}/>
                            ))
                        }
                        {
                            isLoading && <LoadingCard/>
                        }
                    </div>
                </div>
            </div>
            {selectedPackage?.name !== "FREE" && <PaymentMethod
                onClickBuy={() => {
                    setOpen(true)
                }}
            />}
            <div
                className={`px-8   lg:px-[7rem] mt-10 flex py-2 justify-center items-center  flex-col ${className}`}>
                <p className={"text-center  w-full lg:w-1/2 my-10 text-black text-xl lg:text-[2.25rem] font-[700]"}>
                    Benefits of VIP
                </p>

                <BenefitsTable table={VipTable} className={"mb-4"}/>

            </div>
        </div>


    )
}